export default "__VITE_ASSET__C6Eww_Ak__"